const polishToEnglish: Record<string, string> = {
	ą: 'a',
	ć: 'c',
	ę: 'e',
	ł: 'l',
	ń: 'n',
	ó: 'o',
	ś: 's',
	ź: 'z',
	ż: 'z',
	Ą: 'a',
	Ć: 'c',
	Ę: 'e',
	Ł: 'l',
	Ń: 'n',
	Ó: 'o',
	Ś: 's',
	Ź: 'z',
	Ż: 'z',
}

const useTDynamicCache = createGlobalState(() => new Map<string, string>())

export const usei18nService = () => {
	const { $i18n } = useNuxtApp()
	const locale = $i18n.locale
	const locales = $i18n.locales
	const localePath = useLocalePath()
	const $t = (key: string) => $i18n.t(key).toString()

	const tDynamicCache = useTDynamicCache()

	const getLocaleLang = () => {
		return locale.value
	}

	const getLocaleLangs = () => {
		return locales
	}

	const localeString = (str: string | Record<string, string>) => {
		return typeof str === 'string' ? str : str[locale.value]
	}

	const $tDynamic = (path: string, key: string) => {
		if (!path || !key) return ''

		const cacheKey = `${locale.value}:${path}:${key}`
		if (tDynamicCache.has(cacheKey)) return tDynamicCache.get(cacheKey)!

		const cityTranslationKey = key
			.toLowerCase()
			.split('')
			.map((char) => polishToEnglish[char] || char)
			.join('')
			.replace(/ /g, '_')

		let result: string
		if ($t(`data.cities.${cityTranslationKey}`) !== `data.cities.${cityTranslationKey}`) {
			result = $t(`data.cities.${cityTranslationKey}`)
		} else if ($t(`${path}.${key}`) === `${path}.${key}`) {
			result = key
		} else {
			result = $t(`${path}.${key}`)
		}

		tDynamicCache.set(cacheKey, result)
		return result
	}

	const changeLang = async (lang: 'en' | 'pl', urlSlice?: string) => {
		const route = useRoute()
		const currentRouteName = route.name?.toString()
		let pathToRedirect = ''

		// handle pl lang - no prefix in that case
		if (lang === 'pl' && currentRouteName?.includes('index')) {
			pathToRedirect = localePath('/', lang)
		} else if (currentRouteName?.includes('blog-newsTitle')) {
			const baseName = currentRouteName.slice(0, -5)
			pathToRedirect = urlSlice ? localePath({ name: baseName, params: { newsTitle: [urlSlice] } }, lang) : localePath('blog', lang)
		} else if (route.fullPath.includes('wypozyczalnia-samochodow-elektrycznych')) {
			pathToRedirect = localePath('/', lang)
		} else {
			const baseName = currentRouteName?.slice(0, -5)
			pathToRedirect = urlSlice ? localePath({ name: baseName, params: { urlSlug: urlSlice } }, lang) : localePath(baseName ?? '/', lang)
		}

		$i18n.setLocale(lang)
		await navigateTo(pathToRedirect)
	}

	const convertToKeyFormat = (inputString: string, maxWords = 6) => {
		if (!inputString || typeof inputString !== 'string') return ''
		const words = inputString
			.toLowerCase()
			.split(/[^a-z0-9]+/)
			.filter((word) => word !== '')

		const truncatedWords = words.slice(0, maxWords)

		return truncatedWords.join('_')
	}

	return {
		getLocaleLangs,
		getLocaleLang,
		localeString,
		changeLang,
		convertToKeyFormat,
		$tDynamic,
	}
}
